import React from 'react'
import { Box } from '@mantine/core'

export interface AiFillStatusAnnouncerProps {
  message: string | null
}

/** Screen-reader announcement for AI fill / extract outcomes (mirrors toast text). */
export default function AiFillStatusAnnouncer ({ message }: AiFillStatusAnnouncerProps) {
  return (
    <Box
      component="span"
      role="status"
      aria-live="polite"
      aria-atomic="true"
      sx={{
        position: 'absolute',
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: 0
      }}
    >
      {message ?? ''}
    </Box>
  )
}
